export default __webpack_public_path__ + "static/media/POPPINS-LIGHT.3fda0a0e.TTF";